export const modal = {
  modifyTitle: "EDYTUJ REZERWACJĘ",
  createTitle: "UTWÓRZ REZERWACJĘ",
  modifyAction: "Edytuj rezerwację",
  createAction: "Utwórz rezerwację",
  processing: "Przetwarzanie rezerwacji...",

  selectRoomType: "Wybierz typ pokoju",
  selectAccommodation: "Wybierz zakwaterowanie",

  quantity: "Ilość",
  arrival: "Przyjazd",
  departure: "Wyjazd",
  guestName: "Imię i nazwisko gościa",
  email: "E-mail",
  phone: "Telefon",
  guestsNumber: "Liczba gości",
  price: "Cena",
  cancel: "Anuluj",

  noTemplateSummary: "Brak aktywnego szablonu",
  noTemplateDetail: "Brak dostępnego szablonu",

  limitReachedSummary: "Osiągnięto limit",
  limitPromotionDetail: "Nie można dodać więcej niż 1 promocję",
  limitTaxDetail: "Nie można dodać więcej niż 1 podatek",

  validations: {
    fillRequired: "Prosimy wypełnić wszystkie wymagane pola.",
    phoneMin: "Numer telefonu musi mieć co najmniej 5 cyfr.",
    selectDates: "Prosimy wybrać daty przyjazdu i wyjazdu.",
    guestsMin: "Liczba gości musi wynosić co najmniej 1.",
    priceNegative: "Cena nie może być ujemna.",
  },
};

export default modal;
